type TUnit = [value: number, suffix: string]

/** The unit every count past the early return falls back to, so the lookup below needs no dead branch. */
const KILO: TUnit = [1e3, 'k']

/** Larger units, biggest first — the JS scans from the top and stops at the first it reaches. */
const LARGER_UNITS: TUnit[] = [
    [1e18, 'e'],
    [1e15, 'p'],
    [1e12, 't'],
    [1e9, 'b'],
    [1e6, 'm'],
]

/**
 * Counter label for plays and results — a port of audio-web `shortNumber`, not
 * `getNumber(n, { format: 'short' })`: `Intl` compact notation prints `11.9K`, the product prints
 * `11.9k`, and the two diverge again past 999 950 (`1M` vs `1000k`). Pinned by `shortCount.test.ts`.
 */
export const shortCount = (count: number): string => {
    const [kilo] = KILO

    if (count < kilo) {
        return String(count)
    }

    const [value, suffix] = LARGER_UNITS.find(([threshold]) => count >= threshold) ?? KILO

    return (count / value).toFixed(1).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + suffix
}
